import { render } from "./ColumnDisplayRules.vue?vue&type=template&id=b0c1dff2"
import script from "./ColumnDisplayRules.vue?vue&type=script&lang=js"
export * from "./ColumnDisplayRules.vue?vue&type=script&lang=js"

import "./ColumnDisplayRules.vue?vue&type=style&index=0&id=b0c1dff2&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.8.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__